<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <b-button size="sm">Click to Sign</b-button>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <signature-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'description',
              value: properties.description,
              defaultValue: '',
              form: this.form
            })
          : properties.description
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <div class="sign-result" v-if="controlValue">
        <img style="width: 100%;" :src="controlValue.signature" />
        <div class="text-center border-top">
          <small>{{ controlValueSigner }} </small><br />
          <small>{{ formatDate(controlValue.date) }}</small>
        </div>
      </div>
      <div class="d-flex justify-content-between sign-result mt-2">
        <b-button v-if="!controlValue" @click="showSignPadShown" size="sm"
          >Click to Sign</b-button
        >
        <b-button
          v-if="controlValue"
          @click="clearSignatureForm"
          variant="danger"
          size="sm"
          class="ml-2"
          >Clear</b-button
        >
      </div>

      <b-modal
        v-model="signPadShown"
        title="Please Sign"
        @ok="saveSignature"
        @cancel="disconectSigWeb()"
        @hide="disconectSigWeb()"
        centered
        size="md"
        no-close-on-backdrop
        header-bg-variant="primary"
        header-text-variant="white"
        @show="initializeTopazPad()"
        header-class="bg-purple"
      >
        <template v-slot:modal-footer="{ ok, cancel }">
          <div class="d-flex flex-row justify-content-between w-100">
            <div>
              <b-button
                variant="primary"
                @click="useMySignature"
                v-if="
                  currentUser &&
                    currentUser.signature &&
                    properties.type != 'client'
                "
              >
                Use My Signature
              </b-button>
            </div>
            <div>
              <b-button
                class="bg-med-light-gray"
                variant="light"
                @click="cancel()"
              >
                Cancel
              </b-button>
              <b-button class="ml-2" variant="primary" @click="ok()">
                Ok
              </b-button>
            </div>
          </div>
        </template>
        <template v-slot:modal-ok="{}">Ok</template>
        <template v-slot:modal-cancel="{}">Cancel</template>
        <b-form-group v-if="isTopazIntalled" label="Mode">
          <b-form-radio-group v-model="padType">
            <b-row>
              <b-col>
                <b-form-radio value="topaz">Topaz</b-form-radio>
              </b-col>
              <b-col>
                <b-form-radio value="mouse">Mouse</b-form-radio>
              </b-col>
            </b-row>
          </b-form-radio-group>
        </b-form-group>
        <div class="d-flex flex-row justify-content-center">
          <div>
            <VueSignaturePad
              class="border mx-auto"
              width="350px"
              height="150px"
              ref="signaturePad"
              :style="{ display: padType == 'mouse' ? 'block' : 'none' }"
            />
            <canvas
              :style="{ display: padType == 'topaz' ? 'block' : 'none' }"
              class="border mx-auto"
              ref="topaz-canvas"
              width="350"
              height="150"
            />
            <div class="d-flex flex-row justify-content-end mt-1">
              <a href="#" @click="clearSignature">Clear All</a>
            </div>
          </div>
        </div>
        <div
          v-if="properties.dateEditable"
          class="d-flex flex-row justify-content-center"
          style="width: 350px;"
        >
          <b-form-group
            class="d-flex justify-content-center"
            label="Date & Time"
          >
            <date-time-picker v-model="dateTime" />
          </b-form-group>
        </div>
      </b-modal>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
    >
      <div class="sign-result" v-if="controlValue">
        <img style="width: 100%;" :src="controlValue.signature" />
        <div class="text-center border-top">
          <small>{{ controlValueSigner }}</small
          ><br />
          <small>{{ formatDate(controlValue.date) }}</small>
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import {
  formatDate,
  formatDateTimeMysql,
  formatDateTimeSql
} from "../../../../helpers/date";
import SignatureV1Properties from "./SignatureV1Properties.vue";
import DateTimePicker from "../../../controls/DateTimePicker";

let tabletState = null;

export default {
  name: "SignatureV1",
  components: { SignatureV1Properties, DateTimePicker },
  props: ["showType", "properties", "form", "id", "results", "formId"],

  data() {
    return {
      signPadShown: false,
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
      padType: "mouse",
      dateTime: null
    };
  },
  mounted() {
    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue: this.properties.value
      });
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    showSignPadShown() {
      this.signPadShown = true;
      this.dateTime = formatDateTimeMysql(this.getCurrentAdjustedDateTime());
      setTimeout(() => {
        this.$refs.signaturePad.resizeCanvas();
      }, 250);
    },
    formatDate(date) {
      return formatDate(date);
    },
    saveSignature(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (this.padType == "topaz") {
        window.SetSigCompressionMode(1);
        let signatureString = window.GetSigString();
        let signatureCanvas = this.$refs["topaz-canvas"];
        let canvasContext = signatureCanvas.getContext("2d");
        window.SetDisplayXSize(440);
        window.SetDisplayYSize(100);
        window.SetJustifyMode(0);
        window.ClearTablet();
        window.SetSigCompressionMode(1);
        window.SetSigString(signatureString, canvasContext);
        window.SetJustifyMode(5);
        window.SetTabletState(0, tabletState);
        let imgSignature = signatureCanvas.toDataURL();
        this.controlValue = {
          signature: `${imgSignature}`,
          ...this.getSignatureMetadata()
        };

        this.disconectSigWeb();
        this.signPadShown = false;
      } else {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        if (!isEmpty) {
          this.controlValue = {
            signature: data,
            ...this.getSignatureMetadata()
          };
        }
        this.disconectSigWeb();
        this.signPadShown = false;
      }
    },
    sigImageCallback(data) {
      this.controlValue = {
        signature: `data:image/png;base64,${data}`,
        ...this.getSignatureMetadata()
      };

      this.disconectSigWeb();
      this.signPadShown = false;
    },
    disconectSigWeb() {
      if (this.isTopazIntalled) {
        window.ClearTablet();
        window.SetTabletState(0, tabletState);
        clearInterval(tabletState);
      }
    },
    clearSignature() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature();
      }
      if (this.isTopazIntalled) {
        window.ClearTablet();
      }
    },
    clearSignatureForm() {
      this.controlValue = null;
    },
    useMySignature() {
      this.controlValue = {
        signature: this.currentUser.signature,
        ...this.getSignatureMetadata()
      };
      this.signPadShown = false;
    },
    initializeTopazPad() {
      const self = this;
      setTimeout(() => {
        try {
          self.padType = self.isTopazIntalled ? "topaz" : "mouse";
          if (self.isTopazIntalled) {
            let signatureCanvas = self.$refs["topaz-canvas"];
            let canvasContext = signatureCanvas.getContext("2d");
            window.SetDisplayXSize(500);
            window.SetDisplayYSize(100);
            window.SetTabletState(0, tabletState);
            window.SetJustifyMode(0);
            tabletState =
              window.SetTabletState(1, canvasContext, 50) || tabletState;
            window.ClearTablet();
          }
        } catch (e) {
          self.isTopazIntalled = false;
          // If exception throws, means the current machine doesn't have the SignaturePad driver.
        }
      }, 250);
    },
    getSignatureMetadata() {
      return {
        date: formatDateTimeSql(
          this.properties.dateEditable
            ? this.dateTime
            : this.getCurrentAdjustedDateTime()
        ),
        user: this.currentUser
          ? {
              firstName: this.currentUser.firstName,
              lastName: this.currentUser.lastName,
              middleName: this.currentUser.middleName,
              credentials: this.currentUser.credentials
            }
          : "",
        client: this.client
          ? {
              firstName: this.client.firstName,
              middleName: this.client.middleName,
              lastName: this.client.lastName,
              mrn: this.client.mrn
            }
          : ""
      };
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          ${
            this.controlValue
              ? `
          <div style="max-width: 350px; width: 100%;">
            <img style="width: 100%;" src="${this.controlValue.signature}" />
            <div class="text-center border-top">
              <small>${this.controlValueSigner}</small
              ><br />
              <small>${formatDate(this.controlValue.date)}</small>
            </div>
          </div>
          `
              : ""
          }
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      client: state => state.form.client
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      isTopazIntalled: state => state.isTopazIntalled
    }),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    controlValueSigner() {
      switch (this.properties.type) {
        case "client":
          return this.formatClient(
            this.controlValue.client.firstName,
            this.controlValue.client.middleName,
            this.controlValue.client.lastName,
            this.controlValue.client.mrn
          );
        case "general":
        default:
          return "";
        case "user":
          return this.formatUser(this.controlValue.user);
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  },
  watch: {
    padType: function(newValue) {
      if (newValue == "mouse") {
        setTimeout(() => {
          this.$refs.signaturePad.resizeCanvas();
        }, 250);
      }
    }
  }
};
</script>

<style scoped>
.sign-result {
  max-width: 350px;
  width: 100%;
}
</style>
